import { RealmOrigin } from 'types/RealmOrigin';
import { envVar } from 'util/Util/EnvVar';
import { DEFAULT_THEME } from 'context/ThemeContext';

export function origin(): RealmOrigin {
  if (window.location.hostname.includes('agencydrive')) {
    return RealmOrigin.AgencyDrive;
  } else {
    if (envVar('APP_ENV', false) === 'development') {
      return DEFAULT_THEME;
    }
    return RealmOrigin.Storro;
  }
}
